import React from 'react'
import PropTypes from "prop-types"
import Component from "./Component";
import {closestParentByTag} from "../../utils/DomUtils";
import {withTranslation} from "react-i18next";
import {PAGE_SIZE, SORT, SORT_DIRECTIONS} from "../../hooks/table/tableHook";
import ShimmerLoader from "./ShimmerLoader";

class Table extends Component {
  constructor(props) {
    super(props);
    this.columnWidthSum = undefined;

    this._onCheckAllClick = this._onCheckAllClick.bind(this);
    this._onSortCellMouseDown = this._onSortCellMouseDown.bind(this);
  }

  render() {

    return (
      <div className="flex-grow-1">
        <table className={"table is-stripped is-fullwidth" + (this.props.disabled ? " is-disabled" : " is-hoverable is-selectable")}>
          <thead className={this.props.data.length || "empty"}>
          <tr>
            {
              this.props.isChecked && this.props.onCheckAll && this.props.onCheckNone &&
              <th className={"table-checkbox has-width-1" + (this.props.allChecked ? " all-checked" : "")} onClick={this._onCheckAllClick}>
              <span
                className={"fz " + (this.props.allChecked ? "fz-check has-text-success" : this.props.noneChecked ? "fz-times has-text-danger" : "fz-times has-text-grey")}/>
              </th>
            }
            {
              this.props.columns.map((column, index) =>
                  <th
                      key={index}
                      data-column-id={column.id} colSpan={column["colspan"]} className={column.className}
                      style={this._getColumnWidthStyle(column)}
                      onMouseDown={this._onSortCellMouseDown}>
                    <span className={this._getSortClass((column.sortId ? column.sortId : column.id))}>{column.name}</span>

                  </th>
              )
            }
          </tr>
          </thead>
          {<tbody className="table-content" onClick={this._onRowClick.bind(this)}>
          {
            (!this.props.loading && this.props.data && this.props.data.length > 0 && this.props.data.map((row, rowIndex) =>
              <tr
                  key={row[this.props.rowId || "id"] !== undefined ? row[this.props.rowId || "id"] : rowIndex}
                  data-row-id={row[this.props.rowId || "id"]}
                  className={this._getRowGroupBorderClass(rowIndex) +
                      (String(this.props.selection?.[this.props.rowId || "id"]) === String(row[this.props.rowId || "id"]) ? "is-selected" : "") +
                      (this.props.isChecked && this.props.isChecked(row[this.props.rowId || "id"]) ? " is-checked" : "") +
                      (this.props.subRowId && !!row[this.props.subRowId] ? " is-sub-row" : "")}
              >
                {
                  this.props.isChecked &&
                  <td className="table-checkbox has-vertical-align-middle">
                    <span className={"fz " + (this.props.isChecked(row[this.props.rowId || "id"]) ? "fz-check has-text-success" : "fz-times has-text-danger")}/>
                  </td>
                }
                {
                  this.props.columns.map((column, index) =>
                    <td key={index} data-column-name={column.name} className={(this.props.groupRowsBy ? "hide-default-bottom-border " : "") + column.className}>
                      <div className={`loadable ${column.id === this.props.groupRowsBy ? this._getGroupedColumnCellClass(column.id, rowIndex) : ''}`}>
                        {(column.cellComponent ? this._getCellComponent(column, row) : this._getCellContent(row[column.id]))}
                      </div>
                    </td>
                  )
                }
              </tr>
            )
            )
          }
          {
            // This creates a PAGE_SIZE of loading rows, it indicates page loading and prevents view shifts when transitioning.
            (this.props.loading &&
              (new Array(PAGE_SIZE)
                  .fill({id: null})
                  .map((row, index) =>
                     <tr key={"loadingPlaceholder_" + index}>
                       {
                         this.props.columns.map((column, index) =>
                             <td key={index} data-column-name={column.name}
                                 className={(this.props.groupRowsBy ? "hide-default-bottom-border " : "") + column.className}>
                               <ShimmerLoader />
                             </td>
                         )
                       }
                     </tr>
               )
              )
            )
          }
          {this.props.children}
          </tbody>
          }
          {
            //this.props.loading &&
            <tbody className="table-loadable">
            <tr className="has-no-background">
            {
              this.props.columns.map((item, index) =>
                <td key={index}>
                  <div className="loadable">&nbsp;</div>
                </td>
              )
            }
          </tr>
          <tr className="has-no-background has-opacity-70">
            {
              this.props.columns.map((item, index) =>
                <td key={index}>
                  <div className="loadable">&nbsp;</div>
                </td>
              )
            }
          </tr>
          <tr className="has-no-background has-opacity-50">
            {
              this.props.columns.map((item, index) =>
                <td key={index}>
                  <div className="loadable">&nbsp;</div>
                </td>
              )
            }
          </tr>
          <tr className="has-no-background has-opacity-30">
            {
              this.props.columns.map((item, index) =>
                <td key={index}>
                  <div className="loadable">&nbsp;</div>
                </td>
              )
            }
          </tr>
          </tbody>
  }
          {this.props.footer &&
            <tfoot className="has-text-weight-bold">
            {this.props.footer.map((row, rowIndex) =>
              <tr key={rowIndex}>
                {this.props.columns.map((column, columnIndex) =>
                  <td className={columnIndex !== 0 ? "" : "has-no-column-name"} data-column-name={columnIndex !== 0 ? column.name : ''} key={columnIndex}>{row[column.id]}</td>
                )}
              </tr>
              )}
            </tfoot>
          }
          {
            this.props.data.length === 0 && !this.props.loading &&
            <tfoot className="table-empty">
            <tr>
              <td colSpan={this.props.columns.length}>
                <div className="empty-table">
                  <p>
                    <i className="fz fz-empty-set extra-large"/>
                  </p>
                  <p>{this.props.emptyText || this.props.t("No data!")}</p>
                </div>
              </td>
            </tr>
            </tfoot>
          }
        </table>
      </div>
    );
  }

  //UI
  _getColumnWidthStyle(column) {
    if (isNaN(this.columnWidthSum)) {
      this.columnWidthSum = this.props.columns.reduce(function (total, column) {
        return total + (column["stretch"] ? parseInt(column["stretch"]) : 0);
      }, 0);
    }
    if (column["stretch"]) {
      return {width: 100 / this.columnWidthSum * parseInt(column["stretch"]) + "%"};
    }

    return {};
  }

  _getSortClass(columnId) {
    if (this.props.onSort == null) {
      return ""
    }
    return this.props.sort?.[columnId] ? ("sort " + this.props.sort[columnId]) : "";
  }

  _getRowGroupBorderClass(rowIndex) {
    if (!this.props.groupRowsBy || rowIndex >= this.props.data.length-1) {
      return ""
    }
    const rowValue = this.props.data[rowIndex][this.props.groupRowsBy];
    const nextRowValue = this.props.data[rowIndex+1][this.props.groupRowsBy];
    return rowValue !== nextRowValue ? "group-bottom-border " : "";
  }

  _getGroupedColumnCellClass(columnId, rowIndex) {
    if (this._isFirstCellInGroup(columnId, rowIndex)) {
      return 'group-title-column'
    } else {
      return 'hide-cell-content'
    }
  }

  _isFirstCellInGroup(columnId, rowIndex) {
    if (columnId === this.props.groupRowsBy &&
        rowIndex > 0 &&
        rowIndex < this.props.data.length &&
        this.props.data[rowIndex][this.props.groupRowsBy] === this.props.data[rowIndex-1][this.props.groupRowsBy]) {
        return false;
    }
    return true;
  }

  _getCellContent(content) {
    if (content === true) {
      return (<span className="icon"><i className="fz fz-check has-text-success"/></span>)
    }
    if (content === false) {
      return (<span className="icon"><i className="fz fz-times has-text-danger"/></span>)
    }
    if (content == null) {
      return <div>/</div>
    }
    return content;
  }

  _getCellComponent(column, row) {
    if (column.cellComponent(row) == null) {
      return <div>/</div>
    }
    return column.cellComponent(row);
  }

  //EVENTS
  _onSortCellMouseDown(event) {
    if (this.props.disabled) {
      return;
    }
    const column = closestParentByTag("TH", event.target).getAttribute("data-column-id");
    this._sort(column);
    event.preventDefault();
    return false;
  }

  _onCheckAllClick(event) {
    const cell = closestParentByTag("TH", event.target);
    if (cell && cell.classList.contains("all-checked")) {
      this.props.onCheckNone && this.props.onCheckNone();
    } else {
      this.props.onCheckAll && this.props.onCheckAll();
    }
  }

  _onRowClick(event) {
    if (this.props.disabled) {
      return;
    }
    const cell = closestParentByTag("TD", event.target);
    const row = closestParentByTag("TR", cell);

    if (row) {
      const rowId = String(row.getAttribute("data-row-id"));
      const data = this.props.data.find(item => String(item[this.props.rowId || "id"]) === rowId);

      if (cell && cell.classList.contains("table-checkbox") && this.props.isChecked) {
        //handle row check
        this.props.onCheck && this.props.onCheck(data[this.props.rowId || "id"]);
      } else {
        //handle row selection
        if (this.props.onSelection) {
          this.props.onSelection(String(this.props.selection?.[this.props.rowId || "id"]) === rowId ? this.props.enableDeselection ? undefined : data : data);
        }
      }
    }
  }

  //FUNCTIONS
  _sort(columnId) {

    if (this.props.columns.find((column) => column.id === columnId)?.disableSort === true) {
      return
    }
    let sortByField = this.props.columns.find((column) => column.id === columnId)?.sortId || columnId;
    const sort = {};
    sort[sortByField] = this.props.sort?.[sortByField] ? SORT_DIRECTIONS[this.props.sort[sortByField]] : SORT.asc;

    this.props.onSort && this.props.onSort(sort);
  }
}

Table.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  emptyText: PropTypes.string,
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  selection: PropTypes.object,
  onSelection: PropTypes.func,
  sort: PropTypes.object,
  onSort: PropTypes.func,
  isChecked: PropTypes.func,
  onCheck: PropTypes.func,
  allChecked: PropTypes.bool,
  enableDeselection: PropTypes.bool,
  onCheckAll: PropTypes.func,
  noneChecked: PropTypes.bool,
  onCheckNone: PropTypes.func,
  rowId: PropTypes.string,
  subRowId: PropTypes.string,
  groupRowsBy: PropTypes.string,
  footer: PropTypes.array,
  loading: PropTypes.bool,
  disabled: PropTypes.bool
};


export default withTranslation()(Table);
